export default __webpack_public_path__ + "static/media/coming-soon.a9fd0da3.jpg";